import { render, staticRenderFns } from "./jumppage.vue?vue&type=template&id=0748b2d2&"
import script from "./jumppage.vue?vue&type=script&lang=js&"
export * from "./jumppage.vue?vue&type=script&lang=js&"
import style0 from "./jumppage.vue?vue&type=style&index=0&id=0748b2d2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports